import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import CustomContext from "../../../_helper/customizer";

const ListOfMenu = ({
  searchToggle,
  searchBar,
  searchValue,
  removeFix,
  setBookmarkItems,
  bookmarkItems,
  searchResult,
}) => {
  const { IsOpen } = useContext(CustomContext);
  const addToBookmark = (event, items) => {
    const index = bookmarkItems.indexOf(items);
    if (index === -1 && !items.bookmark) {
      items.bookmark = true;
      event.currentTarget.classList.add("starred");
      setBookmarkItems([...bookmarkItems, items]);
    } else {
      event.currentTarget.classList.remove("starred");
      bookmarkItems.splice(index, 1);
      setBookmarkItems(bookmarkItems);
      items.bookmark = false;
    }
  };
  return (
    <Fragment>
      <div
        className={`${searchBar ? `Typeahead-menu custom-scrollbar ${searchToggle ? "is-open" : ""}` : `filled-bookmark Typeahead-menu ${IsOpen ? " is-open" : ""} custom-scrollbar`} `}
        id="search-outer"
        style={{
          background: "var(--dropdown-bg)",
          border: "1px solid var(--dropdown-border)",
          borderRadius: "12px",
          boxShadow: "0 16px 48px rgba(0,0,0,0.3)",
          backdropFilter: "blur(20px)",
          maxHeight: "400px",
          overflowY: "auto",
          overflowX: "hidden",
          padding: "8px",
          marginTop: "8px",
        }}
      >
        {searchValue &&
          searchResult.map((data, index) => {
            return (
              <div 
                className="ProfileCard u-cf" 
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  transition: "background 0.15s",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "var(--nav-hover)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                }}
              >
                <div 
                  className="ProfileCard-avatar"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "rgba(99,102,241,0.1)",
                    border: "1px solid rgba(99,102,241,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--brand-indigo)",
                    flexShrink: 0,
                  }}
                >
                  <data.icon size={16} strokeWidth={2} />
                </div>
                <div 
                  className="ProfileCard-details"
                  style={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <div className="ProfileCard-realName">
                    <Link 
                      to={data.path} 
                      className="realname" 
                      onClick={removeFix}
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: 500,
                        color: "var(--text-primary)",
                        textDecoration: "none",
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {data.title}
                    </Link>
                    {searchBar ? (
                      ""
                    ) : (
                      <span className="pull-right">
                        <a href="#javascript">
                          <i
                            className="fa fa-star-o mt-1 icon-star"
                            onClick={(e) => addToBookmark(e, data)}
                          ></i>
                        </a>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </Fragment>
  );
};

export default ListOfMenu;
